
import React, { useEffect } from 'react';
import { Check } from 'lucide-react';

interface ToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  isDark: boolean;
}

export const Toast: React.FC<ToastProps> = ({ message, isVisible, onClose, isDark }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className={`fixed top-24 md:top-28 left-1/2 -translate-x-1/2 z-[100] animate-fade-in-up`}>
      <div className={`flex items-center gap-3 px-6 py-4 rounded-2xl shadow-2xl border backdrop-blur-xl ${isDark ? 'bg-[#1a1c1e] border-white/20 text-white' : 'bg-white border-slate-200 text-slate-800'}`}>
        <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center shrink-0">
          <Check size={18} className="text-white" strokeWidth={3} />
        </div>
        <span className="font-black text-sm md:text-base">{message}</span>
      </div>
    </div>
  );
};
